function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-685-656h1920v1803H-685z"
}), React.createElement("path", {
  d: "M-685-380h1920v1484H-685z"
}), React.createElement("g", {
  transform: "translate(-69.5 -52)"
}, React.createElement("path", {
  d: "M128.8 94.041v10.5H82.95v-10.5h45.85zm-1.75 1.75H84.7v7h42.35v-7zM88.574 80.483 83.06 91.42l-5.424-10.937h10.938zm-3.198 1.966h-4.568l2.264 4.568 2.304-4.568z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-69.5 -56.72)"
}, React.createElement("tspan", {
  x: 87.496,
  y: 138.719
}, "Start")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 71,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/start.0977e5dd.svg";
export { SvgComponent as ReactComponent };